import { Transform, Type } from 'class-transformer';
import {
  ArrayMaxSize,
  IsArray,
  IsIn,
  IsInt,
  IsOptional,
  IsString,
  Max,
  MaxLength,
  Min,
} from 'class-validator';
import {
  SUBSCRIPTION_STATUSES,
  type SubscriptionStatus,
} from '../../constants/subscription-status.constants';

function trimToUndefined({ value }: { value: unknown }): unknown {
  if (typeof value !== 'string') {
    return value;
  }
  const trimmed = value.trim();
  return trimmed === '' ? undefined : trimmed;
}

function toArray({ value }: { value: unknown }): unknown {
  if (value === undefined || value === '') {
    return undefined;
  }
  return Array.isArray(value) ? value : [value];
}

export class SearchMembershipsQueryDto {
  @IsOptional()
  @Transform(trimToUndefined)
  @IsString()
  @MaxLength(120)
  search?: string;

  @IsOptional()
  @Transform(toArray)
  @IsArray()
  @ArrayMaxSize(SUBSCRIPTION_STATUSES.length)
  @IsIn(SUBSCRIPTION_STATUSES, { each: true })
  subscriptionStatus?: SubscriptionStatus[];

  @IsOptional()
  @Transform(trimToUndefined)
  @IsString()
  @MaxLength(60)
  provincia?: string;

  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  page?: number = 1;

  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  @Max(100)
  pageSize?: number = 20;
}
